/* Global Branch Controller (Dashboard as source of truth) */
import AllActionTypes from '../Utility/AllActionTypes';

/* Store the shared list of available branches. */
export const setGlobalBranches = (branches) => ({
    type: AllActionTypes.SET_GLOBAL_BRANCHES,
    payload: branches
});

/*
 * Set the Dashboard branch. This is the ONLY global source of truth.
 * Dispatching this bumps the dashboard version, which invalidates every
 * module-level override so all modules re-sync to this branch.
 */
export const setDashboardBranch = (branch) => ({
    type: AllActionTypes.SET_DASHBOARD_BRANCH,
    payload: branch
});

/*
 * Set a branch locally for a single module. The change is stamped with the
 * current dashboard version so it stays local until the Dashboard branch
 * changes again.
 */
export const setModuleBranch = (moduleId, branch) => ({
    type: AllActionTypes.SET_MODULE_BRANCH,
    payload: { moduleId, branch }
});
